import { Component, OnInit, ElementRef, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AudioPlayerService } from '../../services/audio-player.service';
import { GameService } from '../../services/game.service';
import { ApplicationTextType } from '../../languages/IApplicationText';
import { environment } from '../../../environments/environment';
import { ImgOpenBaggageComponent } from '../../sharedComponents/img-open-baggage/img-open-baggage.component';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit {
  @ViewChild('levelSelector' ) bagageRef!: ElementRef<ImgOpenBaggageComponent>
  showLevelSelector: Boolean = false;
  bottomText = '';
  appVersion = environment.version;
  className = 'dashboard v-broedels';
  constructor(
    private router: Router,
    private authService: AuthService,
    public audio: AudioPlayerService,
    public gameService: GameService,
    private readonly elementRef: ElementRef,
    private readonly cdRef: ChangeDetectorRef
  ) {
    // console.warn('Dashboard component');
  }

  ngOnInit() {
      if (this.gameService.isGameCompleted()) {
        const textId: ApplicationTextType = 'dashboard_game_completed';
        this.bottomText = this.audio.getPlay(textId , a => {}).replace('\n', '<br>');
      } else {
      // console.log('activelevel', this.gameService.getActiveLevel());
        const textId: ApplicationTextType = 'dashboard_level' + (this.gameService.getActiveLevel()) as ApplicationTextType;
        this.bottomText = this.audio.getPlay(textId , a => {this.openKoffer(); }).replace('\n', '<br>');
      }
  }

  baggageSvgInserted(svgImage: SVGElement) {
    this.cdRef.detectChanges();
    const layer1 = document.getElementById('Layer_1');
    if (!layer1) {
      return;
    }
    layer1.outerHTML = layer1.outerHTML;

  }

  playBottomText() {
    if (this.gameService.isGameCompleted()) {
      this.audio.getPlay('dashboard_game_completed' as ApplicationTextType);

    } else {
      const activeLevel = this.gameService.getActiveLevel();
      // console.log('play bottom text', activeLevel, 'dashboard_level' + activeLevel);
      this.audio.getPlay('dashboard_level' + activeLevel as ApplicationTextType);
    }
  }

  private openKoffer() {
     if (this.gameService.getActiveLevel() === 0) {
        // this.router.navigate(['/level', 0]);
    }
  }

  setLevel(levelId: number) {
    // console.log('detect set level call', levelId, '/level_' + levelId + '.html');
    this.audio.stop();
    this.router.navigate(['/level', levelId]);
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
    this.audio.stopMusic();
  }

  openLevelSelector() {
    if (this.gameService.getActiveLevel() > 0) {
      this.audio.play('koffer');
      this.showLevelSelector = true;
    } else {
      this.router.navigate(['/level', '0']);
    }
  }

  closeLevelSelector() {
    this.showLevelSelector = false;
    this.cdRef.detectChanges();
    const layer1 = document.getElementById('Layer_1');
    if (!layer1) {
      return;
    }
    layer1.outerHTML = layer1.outerHTML;

  }

}
